import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import * as Sentry from "@sentry/react";
import { PostHogProvider } from "@posthog/react";

const dsn = import.meta.env.VITE_SENTRY_DSN;
const environment = import.meta.env.VITE_APP_ENV;

// Prevent search engines from indexing non-production environments
if (environment && environment !== "production") {
  const meta = document.createElement("meta");
  meta.name = "robots";
  meta.content = "noindex, nofollow";
  document.head.appendChild(meta);
}

if (dsn) {
  Sentry.init({
    dsn,
    enabled: environment === "production" || environment === "staging",
    integrations: [Sentry.replayIntegration()],
    replaysSessionSampleRate: 0.5,
    replaysOnErrorSampleRate: 1.0,
    sendDefaultPii: false,
  });
}

const options = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  defaults: "2025-11-30",
} as const;

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <PostHogProvider
      apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
      options={options}
    >
      <App />
    </PostHogProvider>
  </React.StrictMode>,
);
